var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuantityShipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39954 1.71895C7.59757 1.60898 7.82036 1.55127 8.04688 1.55127C8.27339 1.55127 8.49618 1.60898 8.69421 1.71895L13.7042 4.50162C13.8081 4.55938 13.8946 4.64386 13.9549 4.7463C14.0151 4.84875 14.0469 4.96544 14.0469 5.08429V10.5743C14.0469 10.8122 13.9834 11.0457 13.8627 11.2508C13.7421 11.4558 13.5688 11.6248 13.3609 11.7403L8.69421 14.3323C8.49618 14.4423 8.27339 14.5 8.04688 14.5C7.82036 14.5 7.59757 14.4423 7.39954 14.3323L2.73287 11.7396C2.52511 11.6242 2.35196 11.4554 2.23135 11.2507C2.11074 11.0459 2.04705 10.8126 2.04688 10.575V5.08429C2.04687 4.96544 2.07864 4.84875 2.13889 4.7463C2.19913 4.64386 2.28567 4.55938 2.38954 4.50162L7.39954 1.71895Z",
    stroke: "#2F405A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 3.02563L11.0469 6.35897V8.6923M4.04688 8.2443L6.04688 9.35897",
    stroke: "#2F405A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04688 4.69214L8.04688 8.02547M8.04688 8.02547L14.0469 4.69214M8.04688 8.02547V14.3588",
    stroke: "#2F405A",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityShipIcon);
export default __webpack_public_path__ + "static/media/quantity-ship-icon.99e4df4643d370edd5af48275b391783.svg";
export { ForwardRef as ReactComponent };